import { AdminPageHeader } from '@/components/patterns/admin-page'
import CollectionForm from '@/components/forms/CollectionForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { LibraryBig } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/products/collections/create')({
  component: CollectionCreatePage,
  loader: ({ context }) => {
    if (!context.ability.can('create', 'collections')) throw notFound()
    return { isReadOnly: false }
  },
})

export function CollectionCreatePage() {
  return (
    <div className="space-y-4">
      <AdminPageHeader icon={LibraryBig} title="Create Collection" />
      <CollectionForm />
    </div>
  )
}
